<template>
    <div class="secure-payment">
        <form v-if="AcsUrl" ref="threeDomainSecure" method="post" :action="AcsUrl">
            <input type="hidden" name="creq" :value="creq">
            <input type="hidden" name="threeDSSessionData" :value="threeDSSessionData">
        </form>
    </div>
</template>

<script>
    /*
     * Developer Notes
     *
     * This page appears within an iframe inside /src/components/Checkout/PaymentDetails.vue
     * and is responsible for starting the 3D secure verification process.
     *
     * The form above is auto-submitted, and the user will be shown a form on a third-party
     * website to verify their account details.
     *
     * Once the user submits the form, they will be redirected to the Laravel API to handle
     * the outcome, which in turns redirects them back to this app (still within the iframe),
     * and will load one of the following pages:
     *
     *     /src/views/PaymentSuccessful.vue
     *     /src/views/PaymentUnsuccessful.vue
     *
     * Open up the components above for further details.
     */
    export default {
        name: 'secure-payment',

        data() {
            return {
                AcsUrl: null,
                creq: null,
                threeDSSessionData: null,
            };
        },

        mounted() {
            try {
                this.AcsUrl = this.$route.query.AcsUrl;
                this.creq = this.$route.query.creq;
                this.threeDSSessionData = this.$route.query.threeDSSessionData;

                if (!this.AcsUrl || !this.creq || !this.threeDSSessionData) {
                    window.location.href = '/';
                } else {
                    this.$nextTick(() => this.$refs.threeDomainSecure.submit());
                }
            } catch (error) {
                window.location.href = '/';
            }
        }
    }
</script>
